import * as Yup from 'yup'

export const validationSchemasPretension = (fechaAP, fechaS) => {
    let validation = {};

    validation.idInstanciaPretensiones = Yup.string().required('Este campo es obligatorio.');
    validation.idPosibilidadAcuerdo = Yup.string().required('Este campo es obligatorio.');
    validation.comentario = Yup.string().required('Este campo es obligatorio.');

    if (fechaAP && fechaS) {
        validation.fechaActualizacion = Yup.date().test(
            "fechaActualizacion",
            'Fecha inválida.',
            (value) => {
                let fechaResultAP = true;
                let fechaResultS = true;

                if (value === "" || value === undefined) return true;
                if (fechaAP && fechaAP !== "0000-00-00") fechaResultAP = value >= new Date(fechaAP);
                if (fechaS && fechaS !== "0000-00-00") fechaResultS = value >= new Date(fechaS)

                return fechaResultAP && fechaResultS;
            }
        );
    }
    
    return Yup.object().shape(validation);
}

/* export const validationSchemasPretension = (fechaAP, fechaS) => Yup.object({
    fechaActualizacion: Yup.date().min(fechaAP, 'Fecha invlaida.'),
    fechaActualizacion: Yup.date().min(fechaS, 'Fecha invlaida.'),

    if (fechaAP && fechaS) {
        validationObject.fechaActualizacion = Yup.date().min(fechaAP, 'Fecha invlaida.');
        //validationObject["fechaActualizacion"] = Yup.date().min(fechaS, 'Fecha invlaida.');

        return Yup.object().shape(validationObject);
    }
}) */